import React, { useEffect, useState, useRef } from 'react';
import styles from './PrintComponent.module.scss';
import Print from '@arcgis/core/widgets/Print';

const PrintComponent = (props) => {

  const printDiv = useRef(null);
  const [print, setPrint] = useState(new Print());
  useEffect(() => {
    if (printDiv.current) {
      setPrint(new Print({
        view: props.view,
        // printServiceUrl: 'https://map22.epa.gov/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
        printServiceUrl: 'https://utility.arcgisonline.com/arcgis/rest/services/Utilities/PrintingTools/GPServer/Export%20Web%20Map%20Task',
        container: printDiv.current,
        allowedFormats: ['pdf', 'jpg', 'png8'],
        allowedLayouts: ['letter-ansi-a-landscape', 'letter-ansi-a-portrait',
          'tabloid-ansi-b-landscape', 'tabloid-ansi-b-portrait'],
        templateOptions: { legendEnabled: false }
      }));
    }

  }, [props.view]);

  // This useEffect is really only used to get rid of the no-unused-var warning
  useEffect(() => {}, [print])

  return (
    <>
      <div ref={printDiv} className={styles.PrintComponent} data-testid='PrintComponent'>
      </div>
    </>
  );
}

export default PrintComponent;
